function toThousands(num) {
  if (!num) {
    return 0;
  }
  num = num.toString().split("."); // 分隔小数点
  var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
  var res = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i % 3 === 0 && i !== 0) {
      res.push(","); // 添加分隔符
    }
    res.push(arr[i]);
  }
  res.reverse(); // 再次倒序成为正确的顺序
  if (num[1]) {
    // 如果有小数的话添加小数部分
    res = res.join("").concat("." + num[1]);
  } else {
    res = res.join("");
  }
  // console.log(res);
  return res;
}

function toFixedDigit(num, n) {
  //保留n位
  if (typeof num != "number") {
    return "";
  }

  if (num == 0) {
    return "0.00";
  }

  num = (num / 100).toString();
  var result = "";
  var zeroResult = function(n) {
    var zero = "";
    for (var i = 0; i < n; i++) {
      zero += "0";
    }
    return zero;
  };
  if (num % 1 == 0) {
    //整数
    result = num + "." + zeroResult(n);
  } else {
    //小数
    var num1 = num.split(".");
    if (num1[1].length < n) {
      result = num1[0] + "." + num1[1] + zeroResult(n - num1[1].length);
    } else {
      result = num1[0] + "." + num1[1].substring(0, n);
    }
  }
  if (result == false) {
    result = result == false ? "" : result;
  }
  return result;
}

function download(url,from,form2,){

  let text=url+"?appId=supnr";
  for (const key in from) {
      text+="&"+key+"="+from[key]
  }
  if(form2){
    text+="&"+form2
  }
  console.log(text)
  window.open(text);
}
function download2(url,from,form2,){

  let text=url+"?appId=supnr";
  for (const key in from) {
    if(key!='pageSize' && key!='pageNo' ){ 
      text+="&"+key+"="+from[key]
    }
  }
  if(form2){
    text+="&"+form2
  }
  console.log(text)
  window.open(text);
}
export default {
  toThousands,
  toFixedDigit,
  download,
  download2
};
